/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Server_Reminder_BodyInputs */

const en_us2_push_server_reminder_body = /** @type {(inputs: Push_Server_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's session is waiting for you.`)
};

const pt_br2_push_server_reminder_body = /** @type {(inputs: Push_Server_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu treino de hoje está esperando.`)
};

const es_419_push_server_reminder_body = /** @type {(inputs: Push_Server_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenamiento de hoy te está esperando.`)
};

const pt_pt2_push_server_reminder_body = /** @type {(inputs: Push_Server_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treino de hoje está à tua espera.`)
};

const fr_fr2_push_server_reminder_body = /** @type {(inputs: Push_Server_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta séance du jour t'attend.`)
};

const de_de2_push_server_reminder_body = /** @type {(inputs: Push_Server_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine heutige Einheit wartet auf dich.`)
};

const it_it2_push_server_reminder_body = /** @type {(inputs: Push_Server_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'allenamento di oggi ti aspetta.`)
};

/**
* | output |
* | --- |
* | "Today's session is waiting for you." |
*
* @param {Push_Server_Reminder_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_server_reminder_body = /** @type {((inputs?: Push_Server_Reminder_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Server_Reminder_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_server_reminder_body(inputs)
	if (locale === "es-419") return es_419_push_server_reminder_body(inputs)
	if (locale === "pt-PT") return pt_pt2_push_server_reminder_body(inputs)
	if (locale === "fr-FR") return fr_fr2_push_server_reminder_body(inputs)
	if (locale === "de-DE") return de_de2_push_server_reminder_body(inputs)
	if (locale === "it-IT") return it_it2_push_server_reminder_body(inputs)
	return en_us2_push_server_reminder_body(inputs)
});
export { push_server_reminder_body as "push-server.reminder_body" }